export default __webpack_public_path__ + "static/media/SoftwareContent.82e6f293.md";